
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.4.0
 * Query Engine version: f352a33b70356f46311da8b00d83386dd9f145d6
 */
Prisma.prismaVersion = {
  client: "4.4.0",
  engine: "f352a33b70356f46311da8b00d83386dd9f145d6"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.AIFeedbackEvaluationScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  status: 'status',
  statusMessage: 'statusMessage',
  score: 'score',
  aiFeedbackInferenceId: 'aiFeedbackInferenceId',
  criteria: 'criteria',
  trimWhitespace: 'trimWhitespace',
  variantId: 'variantId',
  dataId: 'dataId',
  inferenceId: 'inferenceId',
  stepExecutionId: 'stepExecutionId'
});

exports.Prisma.AppScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  taskType: 'taskType',
  userId: 'userId',
  modelId: 'modelId',
  isDeleted: 'isDeleted',
  isFeatured: 'isFeatured',
  version: 'version',
  createdAt: 'createdAt',
  modifiedAt: 'modifiedAt',
  shortName: 'shortName',
  description: 'description',
  readme: 'readme',
  primaryVariantId: 'primaryVariantId'
});

exports.Prisma.ClassificationEvaluationScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  status: 'status',
  statusMessage: 'statusMessage',
  trimWhitespace: 'trimWhitespace',
  overallAccuracy: 'overallAccuracy',
  f1ScoreByClass: 'f1ScoreByClass',
  accuracyByClass: 'accuracyByClass',
  precisionByClass: 'precisionByClass',
  recallByClass: 'recallByClass',
  microF1Score: 'microF1Score',
  microAccuracy: 'microAccuracy',
  microPrecision: 'microPrecision',
  microRecall: 'microRecall',
  variantId: 'variantId',
  dataId: 'dataId',
  expectedDataColumnId: 'expectedDataColumnId',
  inferenceId: 'inferenceId'
});

exports.Prisma.CollectionScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  description: 'description',
  type: 'type',
  syncEverySeconds: 'syncEverySeconds',
  paused: 'paused'
});

exports.Prisma.CompositionColumnScalarFieldEnum = makeEnum({
  id: 'id',
  compositionId: 'compositionId',
  inferenceId: 'inferenceId'
});

exports.Prisma.CompositionScalarFieldEnum = makeEnum({
  id: 'id',
  variantId: 'variantId'
});

exports.Prisma.CreditBankScalarFieldEnum = makeEnum({
  id: 'id',
  creditCents: 'creditCents',
  namespaceId: 'namespaceId'
});

exports.Prisma.CustomHumanEvaluationOutputColumnScalarFieldEnum = makeEnum({
  id: 'id',
  dataColumnId: 'dataColumnId',
  stepOutputColumnId: 'stepOutputColumnId'
});

exports.Prisma.CustomHumanEvaluationScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  status: 'status',
  source: 'source',
  metadata: 'metadata',
  metadataVersion: 'metadataVersion',
  inputDataId: 'inputDataId',
  stepExecutionId: 'stepExecutionId',
  scaleProjectAndBatchId: 'scaleProjectAndBatchId'
});

exports.Prisma.CustomHumanEvaluationValueScalarFieldEnum = makeEnum({
  row: 'row',
  metadata: 'metadata',
  status: 'status',
  createdAt: 'createdAt',
  modifiedAt: 'modifiedAt',
  customHumanEvaluationOutputColumnId: 'customHumanEvaluationOutputColumnId',
  dataColumnId: 'dataColumnId'
});

exports.Prisma.DataColumnScalarFieldEnum = makeEnum({
  id: 'id',
  dataId: 'dataId',
  name: 'name'
});

exports.Prisma.DataConnectorScalarFieldEnum = makeEnum({
  id: 'id',
  namespaceId: 'namespaceId',
  displayName: 'displayName',
  dataConnectorType: 'dataConnectorType',
  textSplitter: 'textSplitter',
  embeddingModel: 'embeddingModel',
  vectorStoreId: 'vectorStoreId',
  knowledgeBaseId: 'knowledgeBaseId',
  lastModifiedAt: 'lastModifiedAt',
  syncFrequency: 'syncFrequency',
  deletedAt: 'deletedAt',
  s3AccessKeyId: 's3AccessKeyId',
  s3EncryptedSecretAccessKey: 's3EncryptedSecretAccessKey',
  s3BucketName: 's3BucketName',
  s3Region: 's3Region',
  googleDriveFolderUrl: 'googleDriveFolderUrl',
  confluenceSpaceName: 'confluenceSpaceName',
  s3AccountIdOverride: 's3AccountIdOverride',
  confluenceEmailOverride: 'confluenceEmailOverride',
  confluenceEncryptedApiKeyOverride: 'confluenceEncryptedApiKeyOverride',
  confluenceSiteNameOverride: 'confluenceSiteNameOverride'
});

exports.Prisma.DataConnectorStoredFileScalarFieldEnum = makeEnum({
  id: 'id',
  namespaceId: 'namespaceId',
  dataConnectorId: 'dataConnectorId',
  knowledgeBaseId: 'knowledgeBaseId',
  filename: 'filename',
  updatedByUserAt: 'updatedByUserAt',
  syncStatus: 'syncStatus',
  syncedAt: 'syncedAt',
  latestSyncId: 'latestSyncId',
  deletedAt: 'deletedAt',
  rawFileContentLength: 'rawFileContentLength',
  contentType: 'contentType',
  contentMd5Hash: 'contentMd5Hash',
  s3UrlToRawFile: 's3UrlToRawFile',
  s3UrlToConvertedFile: 's3UrlToConvertedFile',
  uniqueFileId: 'uniqueFileId',
  textChunksCount: 'textChunksCount',
  metadata: 'metadata'
});

exports.Prisma.DataConnectorSyncScalarFieldEnum = makeEnum({
  id: 'id',
  namespaceId: 'namespaceId',
  dataConnectorId: 'dataConnectorId',
  status: 'status',
  totalFilesCount: 'totalFilesCount',
  numFilesInSync: 'numFilesInSync',
  startedTimestamp: 'startedTimestamp',
  endedTimestamp: 'endedTimestamp',
  s3UrlToSyncDetails: 's3UrlToSyncDetails'
});

exports.Prisma.DataLoadJobScalarFieldEnum = makeEnum({
  id: 'id',
  namespaceId: 'namespaceId',
  dataLoaderId: 'dataLoaderId',
  status: 'status',
  totalNumFilesInExternalSource: 'totalNumFilesInExternalSource',
  numFilesInLoadJob: 'numFilesInLoadJob',
  startedTimestamp: 'startedTimestamp',
  endedTimestamp: 'endedTimestamp',
  s3UrlToLoadJobDetails: 's3UrlToLoadJobDetails'
});

exports.Prisma.DataLoaderScalarFieldEnum = makeEnum({
  id: 'id',
  namespaceId: 'namespaceId',
  displayName: 'displayName',
  dataLoaderType: 'dataLoaderType',
  lastModifiedAt: 'lastModifiedAt',
  loadJobFrequency: 'loadJobFrequency',
  deletedAt: 'deletedAt',
  s3BucketName: 's3BucketName',
  s3Region: 's3Region',
  googleDriveFolderUrl: 'googleDriveFolderUrl',
  confluenceSpaceName: 'confluenceSpaceName',
  s3AccountIdOverride: 's3AccountIdOverride',
  confluenceEmailOverride: 'confluenceEmailOverride',
  confluenceEncryptedApiKeyOverride: 'confluenceEncryptedApiKeyOverride',
  confluenceSiteNameOverride: 'confluenceSiteNameOverride'
});

exports.Prisma.DataLoaderStoredFileScalarFieldEnum = makeEnum({
  id: 'id',
  namespaceId: 'namespaceId',
  dataLoaderId: 'dataLoaderId',
  filename: 'filename',
  updatedByUserAt: 'updatedByUserAt',
  loadJobStatus: 'loadJobStatus',
  loadJobStartedAt: 'loadJobStartedAt',
  latestLoadJobId: 'latestLoadJobId',
  deletedAt: 'deletedAt',
  rawFileContentLength: 'rawFileContentLength',
  contentType: 'contentType',
  contentMd5Hash: 'contentMd5Hash',
  s3UrlToRawFile: 's3UrlToRawFile',
  s3UrlToConvertedFile: 's3UrlToConvertedFile',
  uniqueFileId: 'uniqueFileId',
  textChunksCount: 'textChunksCount',
  metadata: 'metadata'
});

exports.Prisma.DataScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  type: 'type',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  isBackfilled: 'isBackfilled'
});

exports.Prisma.DataValueScalarFieldEnum = makeEnum({
  dataColumnId: 'dataColumnId',
  value: 'value',
  row: 'row'
});

exports.Prisma.DatasetColumnScalarFieldEnum = makeEnum({
  id: 'id',
  datasetId: 'datasetId',
  columnName: 'columnName'
});

exports.Prisma.DatasetNewScalarFieldEnum = makeEnum({
  id: 'id'
});

exports.Prisma.DatasetScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  type: 'type',
  appId: 'appId',
  userId: 'userId',
  createdAt: 'createdAt',
  inputColName: 'inputColName',
  outputColName: 'outputColName',
  taxonomy: 'taxonomy',
  taxonomyLowercase: 'taxonomyLowercase',
  taxonomyStripWhitespace: 'taxonomyStripWhitespace'
});

exports.Prisma.DatasetTokensScalarFieldEnum = makeEnum({
  datasetId: 'datasetId',
  modelId: 'modelId',
  maxTokensOutput: 'maxTokensOutput',
  maxTokensOutputStripped: 'maxTokensOutputStripped',
  maxTokensInput: 'maxTokensInput'
});

exports.Prisma.DatasetValueScalarFieldEnum = makeEnum({
  id: 'id',
  datasetId: 'datasetId',
  datasetColumnId: 'datasetColumnId',
  row: 'row',
  value: 'value'
});

exports.Prisma.DatumScalarFieldEnum = makeEnum({
  id: 'id',
  input: 'input',
  output: 'output',
  tokenProbs: 'tokenProbs',
  error: 'error',
  datasetId: 'datasetId',
  key: 'key'
});

exports.Prisma.DeploymentColumnScalarFieldEnum = makeEnum({
  id: 'id',
  deploymentId: 'deploymentId',
  variable: 'variable'
});

exports.Prisma.DeploymentInputScalarFieldEnum = makeEnum({
  id: 'id',
  deploymentColumnId: 'deploymentColumnId',
  row: 'row',
  value: 'value'
});

exports.Prisma.DeploymentInstanceLogScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  responseTimeMs: 'responseTimeMs',
  status: 'status',
  errorMessage: 'errorMessage',
  row: 'row',
  deploymentInstanceId: 'deploymentInstanceId'
});

exports.Prisma.DeploymentInstanceScalarFieldEnum = makeEnum({
  id: 'id',
  variantId: 'variantId',
  deploymentId: 'deploymentId',
  inputDataId: 'inputDataId',
  outputDataColumnId: 'outputDataColumnId',
  defaultInputName: 'defaultInputName'
});

exports.Prisma.DeploymentLogNewScalarFieldEnum = makeEnum({
  id: 'id',
  deploymentColumnId: 'deploymentColumnId',
  value: 'value',
  responseTimeMs: 'responseTimeMs',
  row: 'row'
});

exports.Prisma.DeploymentLogScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  input: 'input',
  datasetName: 'datasetName',
  output: 'output',
  responseTimeMs: 'responseTimeMs',
  status: 'status',
  deploymentId: 'deploymentId',
  executionType: 'executionType'
});

exports.Prisma.DeploymentNewScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  uri: 'uri',
  disabled: 'disabled',
  accessKey: 'accessKey',
  appId: 'appId',
  deploymentInstanceId: 'deploymentInstanceId'
});

exports.Prisma.DeploymentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  uri: 'uri',
  disabled: 'disabled',
  variantId: 'variantId',
  appId: 'appId',
  accessKey: 'accessKey'
});

exports.Prisma.EvaluationScalarFieldEnum = makeEnum({
  id: 'id',
  type: 'type',
  method: 'method',
  status: 'status',
  polling: 'polling',
  lockedUntil: 'lockedUntil',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  endedAt: 'endedAt',
  variantId: 'variantId',
  valDatasetId: 'valDatasetId',
  outputDatasetId: 'outputDatasetId'
});

exports.Prisma.EvaluationStatsScalarFieldEnum = makeEnum({
  id: 'id',
  evaluationId: 'evaluationId',
  overallAccuracy: 'overallAccuracy',
  f1ScoreByClass: 'f1ScoreByClass',
  accuracyByClass: 'accuracyByClass',
  precisionByClass: 'precisionByClass',
  recallByClass: 'recallByClass'
});

exports.Prisma.FileScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  url: 'url',
  mimeType: 'mimeType',
  status: 'status',
  updatedAt: 'updatedAt',
  collectionId: 'collectionId'
});

exports.Prisma.FineTuningScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  host: 'host',
  polling: 'polling',
  lockedUntil: 'lockedUntil',
  appId: 'appId',
  datasetId: 'datasetId',
  jobMetadata: 'jobMetadata',
  status: 'status',
  statusMessage: 'statusMessage'
});

exports.Prisma.FinetuneParametersScalarFieldEnum = makeEnum({
  id: 'id',
  trainDataId: 'trainDataId',
  validationDataId: 'validationDataId',
  expectedDataColumnId: 'expectedDataColumnId',
  stopSequence: 'stopSequence',
  promptId: 'promptId',
  userId: 'userId',
  namespaceId: 'namespaceId',
  derivedModelName: 'derivedModelName',
  baseModelId: 'baseModelId',
  epochs: 'epochs',
  learningRateModifier: 'learningRateModifier'
});

exports.Prisma.HumanEvaluationColumnScalarFieldEnum = makeEnum({
  id: 'id',
  humanEvaluationId: 'humanEvaluationId',
  inferenceId: 'inferenceId'
});

exports.Prisma.HumanEvaluationInstructionScalarFieldEnum = makeEnum({
  id: 'id',
  humanEvaluationId: 'humanEvaluationId',
  taskDescription: 'taskDescription',
  goodInput: 'goodInput',
  badInput: 'badInput'
});

exports.Prisma.HumanEvaluationInstructionV2ScalarFieldEnum = makeEnum({
  id: 'id',
  taskDescription: 'taskDescription',
  goodInput: 'goodInput',
  badInput: 'badInput'
});

exports.Prisma.HumanEvaluationOutputColumnScalarFieldEnum = makeEnum({
  id: 'id',
  dataColumnId: 'dataColumnId',
  stepOutputColumnId: 'stepOutputColumnId'
});

exports.Prisma.HumanEvaluationResultScalarFieldEnum = makeEnum({
  id: 'id',
  humanEvaluationId: 'humanEvaluationId',
  row: 'row',
  value: 'value',
  metadata: 'metadata',
  status: 'status',
  humanEvaluationColumnId: 'humanEvaluationColumnId'
});

exports.Prisma.HumanEvaluationScalarFieldEnum = makeEnum({
  id: 'id',
  datasetId: 'datasetId',
  variantId: 'variantId',
  status: 'status',
  source: 'source',
  scaleProjectAndBatchId: 'scaleProjectAndBatchId'
});

exports.Prisma.HumanEvaluationV2ScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  status: 'status',
  statusMessage: 'statusMessage',
  source: 'source',
  hitRate: 'hitRate',
  variantId: 'variantId',
  inputDataId: 'inputDataId',
  humanEvaluationInstructionId: 'humanEvaluationInstructionId',
  inferenceId: 'inferenceId',
  stepExecutionId: 'stepExecutionId',
  scaleProjectAndBatchId: 'scaleProjectAndBatchId'
});

exports.Prisma.HumanEvaluationValueScalarFieldEnum = makeEnum({
  row: 'row',
  metadata: 'metadata',
  status: 'status',
  createdAt: 'createdAt',
  modifiedAt: 'modifiedAt',
  humanEvaluationOutputColumnId: 'humanEvaluationOutputColumnId',
  dataColumnId: 'dataColumnId'
});

exports.Prisma.HumanRankingColumnScalarFieldEnum = makeEnum({
  id: 'id',
  humanRankingId: 'humanRankingId',
  inferenceId: 'inferenceId'
});

exports.Prisma.HumanRankingResultScalarFieldEnum = makeEnum({
  id: 'id',
  humanRankingId: 'humanRankingId',
  row: 'row',
  value: 'value',
  metadata: 'metadata',
  status: 'status',
  humanRankingColumnId: 'humanRankingColumnId'
});

exports.Prisma.HumanRankingScalarFieldEnum = makeEnum({
  id: 'id',
  datasetId: 'datasetId',
  variantIds: 'variantIds',
  status: 'status',
  source: 'source'
});

exports.Prisma.HyperparametersScalarFieldEnum = makeEnum({
  id: 'id',
  temperature: 'temperature',
  batchSize: 'batchSize',
  learningRate: 'learningRate',
  maxTokens: 'maxTokens',
  stopSequence: 'stopSequence',
  taxonomyEnabled: 'taxonomyEnabled'
});

exports.Prisma.InferenceBatchScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  status: 'status',
  inferenceId: 'inferenceId',
  inferenceProgress: 'inferenceProgress',
  polling: 'polling',
  lockedUntil: 'lockedUntil',
  resultS3Url: 'resultS3Url',
  batchId: 'batchId',
  variantId: 'variantId',
  inputDataId: 'inputDataId',
  inputDataUrl: 'inputDataUrl'
});

exports.Prisma.InferenceColumnScalarFieldEnum = makeEnum({
  id: 'id',
  datasetColumnId: 'datasetColumnId',
  variable: 'variable',
  inferenceId: 'inferenceId'
});

exports.Prisma.InferenceInputScalarFieldEnum = makeEnum({
  id: 'id',
  inferenceColumnId: 'inferenceColumnId',
  row: 'row',
  value: 'value'
});

exports.Prisma.InferenceJobScalarFieldEnum = makeEnum({
  id: 'id',
  type: 'type',
  host: 'host',
  parentId: 'parentId',
  status: 'status',
  polling: 'polling',
  lockedUntil: 'lockedUntil',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  startIndex: 'startIndex',
  endIndex: 'endIndex',
  sliceId: 'sliceId',
  taskId: 'taskId'
});

exports.Prisma.InferenceNewScalarFieldEnum = makeEnum({
  id: 'id',
  status: 'status',
  variantId: 'variantId',
  datasetId: 'datasetId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  endedAt: 'endedAt',
  errorMessage: 'errorMessage'
});

exports.Prisma.InferenceOutputColumnScalarFieldEnum = makeEnum({
  id: 'id',
  dataColumnId: 'dataColumnId',
  stepOutputColumnId: 'stepOutputColumnId'
});

exports.Prisma.InferenceResultScalarFieldEnum = makeEnum({
  id: 'id',
  row: 'row',
  value: 'value',
  status: 'status',
  inferenceId: 'inferenceId',
  tokenProbs: 'tokenProbs'
});

exports.Prisma.InferenceScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  variantId: 'variantId',
  outputDatasetId: 'outputDatasetId'
});

exports.Prisma.InferenceV2ScalarFieldEnum = makeEnum({
  id: 'id',
  status: 'status',
  statusMessage: 'statusMessage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  endedAt: 'endedAt',
  stepExecutionId: 'stepExecutionId',
  inputDataId: 'inputDataId',
  errorRate: 'errorRate'
});

exports.Prisma.InferenceValueScalarFieldEnum = makeEnum({
  row: 'row',
  tokenProbs: 'tokenProbs',
  status: 'status',
  createdAt: 'createdAt',
  modifiedAt: 'modifiedAt',
  inferenceOutputColumnId: 'inferenceOutputColumnId',
  dataColumnId: 'dataColumnId'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
});

exports.Prisma.JsonNullValueInput = makeEnum({
  JsonNull: Prisma.JsonNull
});

exports.Prisma.KnowledgeBaseArtifactChunkScalarFieldEnum = makeEnum({
  id: 'id',
  artifactId: 'artifactId',
  text: 'text',
  status: 'status',
  chunkPosition: 'chunkPosition',
  metadata: 'metadata'
});

exports.Prisma.KnowledgeBaseArtifactScalarFieldEnum = makeEnum({
  id: 'id',
  artifactName: 'artifactName',
  artifactKey: 'artifactKey',
  contentModificationIdentifier: 'contentModificationIdentifier',
  source: 'source',
  extractedTextUrl: 'extractedTextUrl',
  chunkingStrategyConfig: 'chunkingStrategyConfig',
  status: 'status',
  idempotencyKey: 'idempotencyKey',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  knowledgeBaseId: 'knowledgeBaseId',
  s3Bucket: 's3Bucket',
  s3Key: 's3Key',
  awsRegion: 'awsRegion',
  awsAccountId: 'awsAccountId'
});

exports.Prisma.KnowledgeBaseScalarFieldEnum = makeEnum({
  id: 'id',
  namespaceId: 'namespaceId',
  dataConnectorIds: 'dataConnectorIds',
  vectorStoreId: 'vectorStoreId',
  displayName: 'displayName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  embeddingModel: 'embeddingModel',
  metadata: 'metadata'
});

exports.Prisma.KnowledgeBaseUploadScalarFieldEnum = makeEnum({
  id: 'id',
  knowledgeBaseId: 'knowledgeBaseId',
  idempotencyKey: 'idempotencyKey',
  dataSourceConfig: 'dataSourceConfig',
  chunkingStrategyConfig: 'chunkingStrategyConfig',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  temporalWorkflowId: 'temporalWorkflowId'
});

exports.Prisma.KnowledgeBaseV2ScalarFieldEnum = makeEnum({
  id: 'id',
  knowledgeBaseName: 'knowledgeBaseName',
  embeddingModel: 'embeddingModel',
  metadata: 'metadata',
  vectorStoreId: 'vectorStoreId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  namespaceId: 'namespaceId'
});

exports.Prisma.MauveEvaluationScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  status: 'status',
  statusMessage: 'statusMessage',
  score: 'score',
  tokensConsumed: 'tokensConsumed',
  scaleLaunchTaskId: 'scaleLaunchTaskId',
  variantId: 'variantId',
  dataId: 'dataId',
  expectedDataColumnId: 'expectedDataColumnId',
  inferenceId: 'inferenceId',
  stepExecutionId: 'stepExecutionId'
});

exports.Prisma.MigrationV1V2ScalarFieldEnum = makeEnum({
  id: 'id',
  model: 'model',
  appId: 'appId',
  fromId: 'fromId',
  toId: 'toId',
  state: 'state',
  createdAt: 'createdAt',
  metadata: 'metadata'
});

exports.Prisma.ModelParametersScalarFieldEnum = makeEnum({
  id: 'id',
  modelId: 'modelId',
  modelType: 'modelType',
  maxTokens: 'maxTokens',
  temperature: 'temperature',
  stop: 'stop',
  suffix: 'suffix',
  topP: 'topP',
  logprobs: 'logprobs',
  logitBias: 'logitBias'
});

exports.Prisma.ModelScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  host: 'host',
  endpoint: 'endpoint',
  createdAt: 'createdAt',
  datasetId: 'datasetId',
  baseModelId: 'baseModelId',
  order: 'order',
  featured: 'featured',
  isDefault: 'isDefault',
  maxTokens: 'maxTokens',
  inputFormat: 'inputFormat',
  fineTuneEndpoint: 'fineTuneEndpoint',
  finetuneId: 'finetuneId',
  dataId: 'dataId'
});

exports.Prisma.NamespaceKeysScalarFieldEnum = makeEnum({
  id: 'id',
  deploymentKey: 'deploymentKey',
  namespaceId: 'namespaceId'
});

exports.Prisma.NamespaceScalarFieldEnum = makeEnum({
  id: 'id',
  namespaceId: 'namespaceId',
  status: 'status',
  lastPaymentCheck: 'lastPaymentCheck',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  billingPlan: 'billingPlan',
  nextBillingPlan: 'nextBillingPlan',
  changeBillingPlanAt: 'changeBillingPlanAt',
  metadata: 'metadata',
  invoiceStrategy: 'invoiceStrategy',
  usageFlaggedAt: 'usageFlaggedAt',
  orbCustomerId: 'orbCustomerId',
  metronomeCustomerId: 'metronomeCustomerId',
  metronomeFineTuningTrainingPlanId: 'metronomeFineTuningTrainingPlanId',
  metronomeFineTuningInferencePlanId: 'metronomeFineTuningInferencePlanId',
  metronomeBaseModelInferencePlanId: 'metronomeBaseModelInferencePlanId',
  s3AccountId: 's3AccountId',
  confluenceEmail: 'confluenceEmail',
  confluenceEncryptedApiKey: 'confluenceEncryptedApiKey',
  confluenceSiteName: 'confluenceSiteName',
  gcpServiceAccountEmail: 'gcpServiceAccountEmail'
});

exports.Prisma.NullableJsonNullValueInput = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
});

exports.Prisma.OpenAIFinetuneScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  status: 'status',
  statusMessage: 'statusMessage',
  updatedAt: 'updatedAt',
  polling: 'polling',
  lockedUntil: 'lockedUntil',
  appId: 'appId',
  modelId: 'modelId',
  finetuneParameterId: 'finetuneParameterId',
  finetuneJobId: 'finetuneJobId',
  progress: 'progress'
});

exports.Prisma.PermissionScalarFieldEnum = makeEnum({
  userId: 'userId',
  namespaceId: 'namespaceId',
  role: 'role'
});

exports.Prisma.PromptScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  template: 'template',
  templateVarByToken: 'templateVarByToken',
  version: 'version',
  datasetId: 'datasetId',
  dataId: 'dataId',
  systemMessage: 'systemMessage'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.RankingScalarFieldEnum = makeEnum({
  id: 'id'
});

exports.Prisma.ResourceScalarFieldEnum = makeEnum({
  resourceName: 'resourceName',
  resourceId: 'resourceId',
  namespaceId: 'namespaceId'
});

exports.Prisma.ScaleProjectAndBatchScalarFieldEnum = makeEnum({
  id: 'id',
  projectId: 'projectId',
  batchId: 'batchId'
});

exports.Prisma.ScaleTrainFinetuneJobMetadataScalarFieldEnum = makeEnum({
  id: 'id',
  configUri: 'configUri',
  metricsUri: 'metricsUri',
  weightsUri: 'weightsUri',
  shapesUri: 'shapesUri'
});

exports.Prisma.ScaleTrainFinetuneScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  status: 'status',
  statusMessage: 'statusMessage',
  updatedAt: 'updatedAt',
  polling: 'polling',
  lockedUntil: 'lockedUntil',
  appId: 'appId',
  modelId: 'modelId',
  finetuneParameterId: 'finetuneParameterId',
  finetuneJobId: 'finetuneJobId',
  progress: 'progress',
  scaleTrainFinetuneJobMetadataId: 'scaleTrainFinetuneJobMetadataId'
});

exports.Prisma.SliceDatumScalarFieldEnum = makeEnum({
  sliceId: 'sliceId',
  datumId: 'datumId',
  datasetId: 'datasetId',
  index: 'index'
});

exports.Prisma.SliceScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  datasetId: 'datasetId'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.StepDefinitionScalarFieldEnum = makeEnum({
  id: 'id',
  stepType: 'stepType',
  parentId: 'parentId'
});

exports.Prisma.StepExecutionScalarFieldEnum = makeEnum({
  id: 'id',
  stepType: 'stepType',
  status: 'status',
  parentId: 'parentId',
  stepDefinitionId: 'stepDefinitionId'
});

exports.Prisma.StepInputColumnScalarFieldEnum = makeEnum({
  id: 'id',
  dataColumnId: 'dataColumnId',
  stepExecutionId: 'stepExecutionId'
});

exports.Prisma.StepOutputColumnScalarFieldEnum = makeEnum({
  id: 'id',
  outputType: 'outputType',
  dataColumnId: 'dataColumnId',
  stepExecutionId: 'stepExecutionId',
  outputSpecificColumnId: 'outputSpecificColumnId'
});

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  scaleApiKey: 'scaleApiKey',
  openAiApiKey: 'openAiApiKey',
  spellbookApiKey: 'spellbookApiKey',
  metadata: 'metadata',
  agreedToPublicAppsAt: 'agreedToPublicAppsAt'
});

exports.Prisma.VariantNewScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  taxonomy: 'taxonomy',
  hasTaxonomy: 'hasTaxonomy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  appId: 'appId',
  promptId: 'promptId',
  modelParametersId: 'modelParametersId'
});

exports.Prisma.VariantScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  appId: 'appId',
  modelId: 'modelId',
  promptId: 'promptId',
  hyperparametersId: 'hyperparametersId',
  userId: 'userId'
});

exports.Prisma.VectorStoreScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  namespaceId: 'namespaceId',
  openSearchIndexId: 'openSearchIndexId',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  embeddingModel: 'embeddingModel'
});

exports.Prisma.WorkflowDefinitionScalarFieldEnum = makeEnum({
  id: 'id',
  parentObjectType: 'parentObjectType',
  parentObjectId: 'parentObjectId'
});

exports.Prisma.WorkflowEdgeDefinitionScalarFieldEnum = makeEnum({
  id: 'id',
  tailStepDefinitionId: 'tailStepDefinitionId',
  headStepDefinitionId: 'headStepDefinitionId'
});
exports.AppVersion = makeEnum({
  V1: 'V1',
  V2: 'V2'
});

exports.BillingPlan = makeEnum({
  Free: 'Free',
  Team: 'Team',
  Pro: 'Pro',
  Enterprise: 'Enterprise',
  Pilot: 'Pilot'
});

exports.CollectionType = makeEnum({
  Files: 'Files'
});

exports.ContentType = makeEnum({
  ApplicationPdf: 'ApplicationPdf',
  ApplicationPptx: 'ApplicationPptx',
  TextPlain: 'TextPlain',
  GoogleDocument: 'GoogleDocument',
  ConfluenceHTML: 'ConfluenceHTML'
});

exports.DataConnectorSyncStatus = makeEnum({
  Running: 'Running',
  Completed: 'Completed',
  Failed: 'Failed'
});

exports.DataConnectorType = makeEnum({
  LocalUpload: 'LocalUpload',
  S3: 'S3',
  GoogleDrive: 'GoogleDrive',
  Confluence: 'Confluence'
});

exports.DataLoaderStatus = makeEnum({
  Running: 'Running',
  Completed: 'Completed',
  Failed: 'Failed'
});

exports.DataLoaderType = makeEnum({
  S3: 'S3',
  GoogleDrive: 'GoogleDrive',
  Confluence: 'Confluence'
});

exports.DataType = makeEnum({
  UserUploaded: 'UserUploaded',
  InferenceOutput: 'InferenceOutput',
  EvaluationOutput: 'EvaluationOutput',
  DeploymentInput: 'DeploymentInput',
  DeploymentOutput: 'DeploymentOutput'
});

exports.DatasetType = makeEnum({
  Train: 'Train',
  Validation: 'Validation',
  Inference: 'Inference'
});

exports.DeploymentExecutionSourceType = makeEnum({
  API: 'API',
  TestAPI: 'TestAPI',
  GoogleAppsScript: 'GoogleAppsScript'
});

exports.EvaluationMethod = makeEnum({
  Classification: 'Classification',
  ClassificationStripWhitespace: 'ClassificationStripWhitespace',
  AIFeedback: 'AIFeedback',
  Mauve: 'Mauve'
});

exports.EvaluationType = makeEnum({
  Full: 'Full',
  Short: 'Short'
});

exports.FileUploadStatus = makeEnum({
  Pending: 'Pending',
  Completed: 'Completed',
  Errored: 'Errored'
});

exports.FineTuneEndpoint = makeEnum({
  ada: 'ada',
  babbage: 'babbage',
  curie: 'curie',
  davinci: 'davinci'
});

exports.HumanJobSource = makeEnum({
  ScaleRapid: 'ScaleRapid',
  ScaleStudio: 'ScaleStudio'
});

exports.InferenceJobType = makeEnum({
  Inference: 'Inference',
  Evaluation: 'Evaluation',
  Mauve: 'Mauve'
});

exports.InvoiceStrategy = makeEnum({
  Cron: 'Cron',
  Manual: 'Manual'
});

exports.JobStatus = makeEnum({
  Pending: 'Pending',
  Running: 'Running',
  Errored: 'Errored',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
  Backfilled: 'Backfilled'
});

exports.MigrationModel = makeEnum({
  Data: 'Data',
  Variant: 'Variant',
  InferenceJob: 'InferenceJob',
  Evaluation: 'Evaluation',
  Deployment: 'Deployment'
});

exports.MigrationState = makeEnum({
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  Completed: 'Completed',
  Errored: 'Errored',
  Reverted: 'Reverted'
});

exports.ModelFormat = makeEnum({
  Completion: 'Completion',
  Chat: 'Chat'
});

exports.ModelHost = makeEnum({
  ScaleLaunch: 'ScaleLaunch',
  OpenAi: 'OpenAi',
  Ai21: 'Ai21',
  Cohere: 'Cohere',
  Anthropic: 'Anthropic'
});

exports.NamespaceStatus = makeEnum({
  Active: 'Active',
  PaymentRejected: 'PaymentRejected',
  MissingPaymentMethod: 'MissingPaymentMethod'
});

exports.OutputType = makeEnum({
  Inference: 'Inference',
  ScaleLaunchMauve: 'ScaleLaunchMauve',
  HumanEvaluation: 'HumanEvaluation',
  CustomHumanEvaluation: 'CustomHumanEvaluation'
});

exports.ResourceName = makeEnum({
  App: 'App',
  InferenceJob: 'InferenceJob',
  Variant: 'Variant',
  Dataset: 'Dataset',
  Hyperparameters: 'Hyperparameters',
  Model: 'Model',
  FineTuning: 'FineTuning',
  Prompt: 'Prompt',
  Inference: 'Inference',
  Evaluation: 'Evaluation',
  Deployment: 'Deployment',
  Data: 'Data',
  DataColumn: 'DataColumn',
  DeploymentNew: 'DeploymentNew',
  VariantNew: 'VariantNew',
  OpenAIFinetune: 'OpenAIFinetune',
  ScaleTrainFinetune: 'ScaleTrainFinetune',
  InferenceBatch: 'InferenceBatch'
});

exports.Role = makeEnum({
  Owner: 'Owner',
  Reader: 'Reader',
  Writer: 'Writer'
});

exports.SourceType = makeEnum({
  LocalUpload: 'LocalUpload',
  S3: 'S3',
  GoogleDrive: 'GoogleDrive',
  Confluence: 'Confluence'
});

exports.StatusType = makeEnum({
  Pending: 'Pending',
  Running: 'Running',
  Completed: 'Completed',
  Failed: 'Failed',
  Canceled: 'Canceled'
});

exports.StepType = makeEnum({
  Variant: 'Variant',
  ScaleLaunchMauve: 'ScaleLaunchMauve',
  HumanEvaluation: 'HumanEvaluation',
  AIFeedbackEvaluation: 'AIFeedbackEvaluation',
  CustomHumanEvaluation: 'CustomHumanEvaluation'
});

exports.StoredFileLoadJobStatus = makeEnum({
  Pending: 'Pending',
  Completed: 'Completed',
  Failed: 'Failed'
});

exports.StoredFileSyncStatus = makeEnum({
  Pending: 'Pending',
  Completed: 'Completed',
  Failed: 'Failed'
});

exports.TaskType = makeEnum({
  Classification: 'Classification',
  Extraction: 'Extraction',
  Generation: 'Generation',
  Summarization: 'Summarization',
  Autocompletion: 'Autocompletion'
});

exports.VariantType = makeEnum({
  Phantom: 'Phantom',
  Real: 'Real'
});

exports.WorkflowParentType = makeEnum({
  Composition: 'Composition'
});

exports.Prisma.ModelName = makeEnum({
  User: 'User',
  App: 'App',
  InferenceJob: 'InferenceJob',
  Variant: 'Variant',
  Dataset: 'Dataset',
  DatasetTokens: 'DatasetTokens',
  Slice: 'Slice',
  SliceDatum: 'SliceDatum',
  Datum: 'Datum',
  Hyperparameters: 'Hyperparameters',
  Model: 'Model',
  Prompt: 'Prompt',
  FineTuning: 'FineTuning',
  Ranking: 'Ranking',
  Inference: 'Inference',
  Evaluation: 'Evaluation',
  EvaluationStats: 'EvaluationStats',
  Deployment: 'Deployment',
  DeploymentLog: 'DeploymentLog',
  Namespace: 'Namespace',
  Permission: 'Permission',
  Resource: 'Resource',
  NamespaceKeys: 'NamespaceKeys',
  CreditBank: 'CreditBank',
  DatasetNew: 'DatasetNew',
  DatasetColumn: 'DatasetColumn',
  DatasetValue: 'DatasetValue',
  InferenceNew: 'InferenceNew',
  InferenceColumn: 'InferenceColumn',
  InferenceInput: 'InferenceInput',
  InferenceResult: 'InferenceResult',
  DeploymentColumn: 'DeploymentColumn',
  DeploymentInput: 'DeploymentInput',
  DeploymentLogNew: 'DeploymentLogNew',
  HumanRanking: 'HumanRanking',
  HumanRankingColumn: 'HumanRankingColumn',
  HumanRankingResult: 'HumanRankingResult',
  HumanEvaluation: 'HumanEvaluation',
  ScaleProjectAndBatch: 'ScaleProjectAndBatch',
  HumanEvaluationColumn: 'HumanEvaluationColumn',
  HumanEvaluationResult: 'HumanEvaluationResult',
  HumanEvaluationInstruction: 'HumanEvaluationInstruction',
  Composition: 'Composition',
  CompositionColumn: 'CompositionColumn',
  Data: 'Data',
  DataColumn: 'DataColumn',
  DataValue: 'DataValue',
  VariantNew: 'VariantNew',
  ModelParameters: 'ModelParameters',
  StepDefinition: 'StepDefinition',
  WorkflowEdgeDefinition: 'WorkflowEdgeDefinition',
  WorkflowDefinition: 'WorkflowDefinition',
  StepExecution: 'StepExecution',
  StepInputColumn: 'StepInputColumn',
  StepOutputColumn: 'StepOutputColumn',
  InferenceOutputColumn: 'InferenceOutputColumn',
  InferenceValue: 'InferenceValue',
  InferenceV2: 'InferenceV2',
  HumanEvaluationInstructionV2: 'HumanEvaluationInstructionV2',
  HumanEvaluationV2: 'HumanEvaluationV2',
  HumanEvaluationOutputColumn: 'HumanEvaluationOutputColumn',
  HumanEvaluationValue: 'HumanEvaluationValue',
  CustomHumanEvaluation: 'CustomHumanEvaluation',
  CustomHumanEvaluationOutputColumn: 'CustomHumanEvaluationOutputColumn',
  CustomHumanEvaluationValue: 'CustomHumanEvaluationValue',
  DeploymentNew: 'DeploymentNew',
  DeploymentInstance: 'DeploymentInstance',
  DeploymentInstanceLog: 'DeploymentInstanceLog',
  ClassificationEvaluation: 'ClassificationEvaluation',
  MauveEvaluation: 'MauveEvaluation',
  AIFeedbackEvaluation: 'AIFeedbackEvaluation',
  Collection: 'Collection',
  File: 'File',
  VectorStore: 'VectorStore',
  FinetuneParameters: 'FinetuneParameters',
  ScaleTrainFinetuneJobMetadata: 'ScaleTrainFinetuneJobMetadata',
  ScaleTrainFinetune: 'ScaleTrainFinetune',
  OpenAIFinetune: 'OpenAIFinetune',
  InferenceBatch: 'InferenceBatch',
  MigrationV1V2: 'MigrationV1V2',
  DataConnector: 'DataConnector',
  DataConnectorSync: 'DataConnectorSync',
  DataConnectorStoredFile: 'DataConnectorStoredFile',
  KnowledgeBase: 'KnowledgeBase',
  DataLoader: 'DataLoader',
  DataLoadJob: 'DataLoadJob',
  DataLoaderStoredFile: 'DataLoaderStoredFile',
  KnowledgeBaseV2: 'KnowledgeBaseV2',
  KnowledgeBaseArtifact: 'KnowledgeBaseArtifact',
  KnowledgeBaseArtifactChunk: 'KnowledgeBaseArtifactChunk',
  KnowledgeBaseUpload: 'KnowledgeBaseUpload'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
